import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './CustomPagination.scss';
import { Input, Pagination } from 'antd';

const CustomPagination = (props): JSX.Element => {
  const [goToPageValue, setGoToPageValue] = useState('');

  const { paginationInfo, fetchFunc } = props;

  const onChangePagination = (page: number): void => {
    fetchFunc(page);
  };

  const goToPage = (eventt): void => {
    if (!Number.isNaN(Number.parseInt(eventt.target.value, 10))) {
      let page = Number.parseInt(eventt.target.value, 10);
      page = Math.max(page, 1);
      page = Math.min(page, paginationInfo.numberOfPages);
      fetchFunc(page);
    }

    setGoToPageValue('');
  };

  const handleGoToPageValue = (eventt): void => {
    setGoToPageValue(eventt.target.value.replace(/\D/g, ''));
  };

  return (
    <div className="CustomPagination">
      <div className="go-to-container">
        Ir para a página
        <Input
          className="go-to-page-input"
          value={goToPageValue}
          onChange={handleGoToPageValue}
          onPressEnter={goToPage}
        />
      </div>
      <Pagination
        className="pagination-default"
        onChange={onChangePagination}
        defaultCurrent={1}
        current={paginationInfo.pageNumber + 1}
        pageSize={paginationInfo.maxSize}
        total={paginationInfo.totalElements}
      />
    </div>
  );
};

CustomPagination.propTypes = {
  paginationInfo: PropTypes.shape({
    maxSize: PropTypes.number.isRequired,
    numberOfPages: PropTypes.number.isRequired,
    pageNumber: PropTypes.number.isRequired,
    totalElements: PropTypes.number.isRequired,
  }).isRequired,

  fetchFunc: PropTypes.func.isRequired,
};

CustomPagination.defaultProps = {};

export default CustomPagination;
